import { AsyncPipe, CommonModule, DecimalPipe, JsonPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { NgbAlertModule, NgbDate, NgbDatepickerModule, NgbDropdownModule, NgbModal, NgbNavModule, NgbTimepickerModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { OutOfOfficeService } from '../../../Model/OutOfOffice/out-of-office.service';
import { SessionService } from '../../../Util/Session/session.service';
import { AttendanceService } from '../../../Model/Attendance/attendance.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import moment from 'moment';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-form-out-of-office',
  standalone: true,
  imports: [NgbNavModule, NgbDatepickerModule, FormsModule, JsonPipe, NgbAlertModule, NgbTimepickerModule, CommonModule, DecimalPipe, AsyncPipe, DataTablesModule, ReactiveFormsModule, AsyncPipe, NgbDropdownModule, RouterOutlet, RouterModule, NgbTooltip, LoaderComponent],
  templateUrl: './form-out-of-office.component.html',
  styleUrl: './form-out-of-office.component.scss'
})
export class FormOutOfOfficeComponent {
  // MinDate = [] as any;
  // MaxDate = [] as any;
  IsRotationalShift: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  isDisabled: boolean = false;

  Attachment: string = '';
  selectedFile: File | null = null;
  ImageUrl: any;
  public User: any = null;
  Regularization = {
    RegularizationAttendanceDetails: [
      // {
      //   DesignationID: null,
      //   DutyID: null,
      //   BranchID: null,
      //   SiteID: null,
      //   ShiftMasterID: null,
      //   AttendanceDate: null,
      //   IsIn: false,
      //   InTime: null,
      //   InReason: null,
      //   IsOut: false,
      //   OutTime: null,
      //   OutReason: null,
      // }
    ] as any,
  };

  RegularizationForSave = {
    RegularizationAttendanceDetails: [
      // {
      //   DesignationID: null,
      //   DutyID: null,
      //   BranchID: null,
      //   SiteID: null,
      //   ShiftMasterID: null,
      //   AttendanceDate: null,
      //   IsIn: false,
      //   InTime: null,
      //   InReason: null,
      //   IsOut: false,
      //   OutTime: null,
      //   OutReason: null,
      // }
    ] as any,
  };

  AttendanceDetail = {
    IsCheckIn: false,//
    SelectType: 'InsertUpdate',//
    EmpMasterId: null,
    EmpCode: null,
    FUllName: null,
    DesignationID: null,
    DutyID: null,
    BranchID: null as any,//
    SiteId: null,
    ShiftMasterID: null,
  };

  constructor(
    private outofoffice: OutOfOfficeService,
    private session: SessionService,
    private _Attendance: AttendanceService,
    private modalService: NgbModal,
    private utility: UtilityService,
    public common: CommonService,
    public toast: ToastService,
    public dateFormate: CustomDateParserFormatter,
    private router: Router,
    protected tooltip: TooltipService,
  ) {
    this.common.getPageRights();
    this.User = this.session.GetUserDetails();
    // this.common.PageRight.IsView = true;
    // this.common.PageRight.IsAdd = true;
    // this.common.PageRight.IsDelete = true;
    // this.common.PageRight.IsEdit = true;
    // this.common.PageRight.IsPrint = true;
  }

  ngOnInit(): void {
    //this.SelectDate('RegistrationDate', null, null);
    this.AttendanceDetail.EmpMasterId = this.session.GetUserDetails().UserId;
    this.GetAttendanceDetails();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  GetAttendanceDetails() {
    this._Attendance.GetAttendanceDetails({ EmpMasterId: this.AttendanceDetail.EmpMasterId, QRSiteID: 0 }).subscribe({
      next: (response) => {
        this.AttendanceDetail.EmpMasterId = response.Table[0].EmpMasterID;
        this.AttendanceDetail.EmpCode = response.Table[0].EmpCode;
        this.AttendanceDetail.FUllName = response.Table[0].FUllName;
        this.AttendanceDetail.DesignationID = response.Table[0].DesignationID;
        this.AttendanceDetail.DutyID = response.Table[0].DutyID;
        this.AttendanceDetail.BranchID = 0;
        this.AttendanceDetail.SiteId = response.Table[0].SiteID;
        this.AttendanceDetail.ShiftMasterID = response.Table[0].ShiftID;
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  dateClass() {
    return (date: NgbDate) => {
      if (this.Regularization.RegularizationAttendanceDetails.findIndex((e: any) => e.AttendanceDate.isSame(date)) >= 0) {
        return 'special-date';
      } else {
        return '';
      }
    };
  }

  RegularizationDateSelect(event: any) {
    this.Regularization.RegularizationAttendanceDetails = [];
    this.removeFile();
    const selectedDate = moment(`${event.year}-${event.month}-${event.day}`, 'YYYY-MM-DD');
    const dayInWords = selectedDate.format('ddd');
    this.isDisabled = true
    this.outofoffice.OutOfOfficeAttendanceDetails({
      SelectType: 1,
      ESS_OutOfOfficeAttendanceDetailsId: 0,
      EmpMasterID: this.AttendanceDetail.EmpMasterId,
      ApprovalStatus: '',
      FromDate: '',
      ToDate: '',
      BranchId: 0,
      ClientId: 0,
      SiteId: 0,
      AttendanceDate: this.dateFormate.format(event),
    }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.Regularization.RegularizationAttendanceDetails.push({
            date: event,
            dayInWords: dayInWords,
            EmpMasterId: response.Table[0]['EmpMasterId'],
            DesignationID: 0,
            DutyID: 0,
            BranchID: 0,
            SiteID: 0,
            ShiftMasterID: 0,
            AttendanceDate: this.dateFormate.format(event),
            InTime: response.Table[0]['InTime'] ? { hour: parseInt(response.Table[0]['InTime'].split(":")[0]), minute: parseInt(response.Table[0]['InTime'].split(":")[1]) } : null,
            OutTime: response.Table[0]['OutTime'] ? { hour: parseInt(response.Table[0]['OutTime'].split(":")[0]), minute: parseInt(response.Table[0]['OutTime'].split(":")[1]) } : null,
            Attachment: null,
            Reason: null,
            IsRotationalShift: false,
          });
        }
        else {
          this.Regularization.RegularizationAttendanceDetails.push({
            date: event,
            dayInWords: dayInWords,
            EmpMasterId: this.AttendanceDetail.EmpMasterId,
            DesignationID: this.AttendanceDetail.DesignationID,
            DutyID: this.AttendanceDetail.DutyID,
            BranchID: this.AttendanceDetail.BranchID,
            SiteID: this.AttendanceDetail.SiteId,
            ShiftMasterID: this.AttendanceDetail.ShiftMasterID,
            AttendanceDate: this.dateFormate.format(event),
            InTime: null,
            OutTime: null,
            Attachment: null,
            Reason: null,
            IsRotationalShift: false,
          });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  CardDelete(index: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Do you want to delete?';

    modalRef.result.then((result: any) => {
      if (result) {
        this.Regularization.RegularizationAttendanceDetails.splice(index, 1);
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.Regularization.RegularizationAttendanceDetails == null || this.Regularization.RegularizationAttendanceDetails.length <= 0) {
        this.toast.show({ message: 'Please select atleast one day ', type: toastTypeEnum.warning });
      } else if (this.Regularization.RegularizationAttendanceDetails.filter((e: any) => e.IsIn && e.InTime == null).length > 0) {
        this.toast.show({ message: 'Please enter in time ', type: toastTypeEnum.warning });
      } else if (this.Regularization.RegularizationAttendanceDetails.filter((e: any) => e.IsOut && e.OutTime == null).length > 0) {
        this.toast.show({ message: 'Please enter out time ', type: toastTypeEnum.warning });
      } else {
        this.SaveRegularizationAttendance();
      }
    }
    else {
      // if (this.Regularization.RegularizationAttendanceDetails != null || this.Regularization.RegularizationAttendanceDetails.length <= 0) {
      //   this.toast.show({ message: 'Please select atleast one day ', type: toastTypeEnum.warning });
      // }
      form.submitted = true;
    }
  }

  async SaveRegularizationAttendance() {
    await this.common.getPageRights();
    this.RegularizationForSave.RegularizationAttendanceDetails = [];
    if (this.Regularization.RegularizationAttendanceDetails.some((e: any) => e.IsIn && e.IsOut && e.OutTime && e.InTime && moment(e.OutTime).isBefore(e.InTime) && !e.IsRotationalShift)) {
      this.toast.show({ message: 'OutTime must be greater than InTime.', type: toastTypeEnum.warning });
    } else {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to submit?';
      modalRef.result.then(result => {
        if (this.common.PageRight.IsAdd) {
          if (result) {
            this.isDisabled = true;
            const data = {
              SelectType: '',
              ESS_OutOfOfficeAttendanceDetailsID: 0,
              EmpMasterId: this.Regularization.RegularizationAttendanceDetails[0].EmpMasterId,
              BranchID: this.AttendanceDetail.BranchID,
              SiteID: this.AttendanceDetail.SiteId,
              DesignationID: this.AttendanceDetail.DesignationID,
              DutyID: this.AttendanceDetail.DutyID,
              ShiftMasterID: this.AttendanceDetail.ShiftMasterID,
              AttendanceDate: this.Regularization.RegularizationAttendanceDetails[0].AttendanceDate,
              InTime: moment(this.Regularization.RegularizationAttendanceDetails[0].AttendanceDate)
                .add(this.Regularization.RegularizationAttendanceDetails[0].InTime.hour, 'hours')
                .add(this.Regularization.RegularizationAttendanceDetails[0].InTime.minute, 'minutes')
                .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
              OutTime: moment(this.Regularization.RegularizationAttendanceDetails[0].AttendanceDate)
                .add(this.IsRotationalShift ? 1 : 0, 'day')
                .add(this.Regularization.RegularizationAttendanceDetails[0].OutTime.hour, 'hours')
                .add(this.Regularization.RegularizationAttendanceDetails[0].OutTime.minute, 'minutes')
                .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
              Attachment: this.Attachment,
              Reason: this.Regularization.RegularizationAttendanceDetails[0].Reason,
              UserId: this.User.UserId
            }
            this.outofoffice.OutOfOfficeAttendanceDetailsInsert(data).subscribe({
              next: (response) => {
                if (response.Error_Code == '696') {
                  this.RegularizationForSave.RegularizationAttendanceDetails = [];
                  this.Regularization.RegularizationAttendanceDetails = [];
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.close();
                    }
                  });
                }
                else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      }, reason => { });
    }
  }

  timeFormate(event: any, type: String, index: number) {
    if (type == 'InTime') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.Regularization.RegularizationAttendanceDetails[index].InTime.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.Regularization.RegularizationAttendanceDetails[index].InTime.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    } else if (type == 'OutTime') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.Regularization.RegularizationAttendanceDetails[index].OutTime.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.Regularization.RegularizationAttendanceDetails[index].OutTime.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    }
  }

  close() {
    this.router.navigate(['/request/outofoffice']);
  }

  onFileSelected(event: any) {
    this.isDisabled = true;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
    if (this.selectedFile) {
      this.uploadToFTP(this.selectedFile);
      this.isDisabled = false;
    } else {
      this.isDisabled = false;
    }
  }
  removeFile() {
    this.selectedFile = null;
    this.Attachment = '';
    const fileInput = document.getElementById('formFileSm') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  viewFile() {
    window.open(this.ImageUrl, '_blank');
  }
  uploadToFTP(file: File) {
    if (!file) {
      return;
    }
    this.isDisabled = true;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.utility.Upload({ 'DomainName': this.User.Domain, 'folder': 'OutofOffice', 'CompanyCode': this.User.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
        if (response.FileName != "") {
          this.Attachment = response.FileName;
          this.ImageUrl = response.Url;
          this.isDisabled = false;
        } else {
          this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      }, (error) => {
        console.error('FTP Upload Error:', error);
        this.isDisabled = false;
      });
    };
  }
}

